/**
 * Shared target-language list for reviewer-facing translation controls.
 * Used by the per-stage TranslateToggle and the Source-document view
 * translation. Codes are ISO 639-1; the Kaycoo translate.text tool accepts
 * them directly.
 */
export interface TranslationTarget {
  code: string;
  label: string;
}

export const TRANSLATION_TARGETS: TranslationTarget[] = [
  { code: 'en', label: 'English' },
  { code: 'fi', label: 'Finnish' },
  { code: 'de', label: 'German' },
  { code: 'fr', label: 'French' },
  { code: 'es', label: 'Spanish' },
  { code: 'pt', label: 'Portuguese' },
  { code: 'it', label: 'Italian' },
  { code: 'sv', label: 'Swedish' },
];

export function languageLabel(code: string): string {
  return TRANSLATION_TARGETS.find((t) => t.code === code)?.label ?? code;
}

/**
 * Single source of truth for the reviewer-facing "translation is view-only"
 * disclaimer. Shown under every rendered translation (whole-document pane and
 * the per-field TranslateToggle) so the copy never drifts between surfaces.
 */
export const TRANSLATION_DISCLAIMER =
  'Translation is view-only. The pipeline agents always read the original ' +
  'text — your approval applies to the source, not the translated copy.';
